export function createLoadingScreen(): HTMLElement {
	const spinner = createSpinner();
	spinner.style.fontSize = '60px';
	const overlay = generateOverlay();
	overlay.append(spinner);

	return overlay;
}

export function createSpinner(): HTMLElement {
	const element = document.createElement('i');
	element.classList.add('icon-spinner', 'icon-spin', 'icon-large');

	return element;
}

export function createImg(src: string, alt: string = ''): HTMLImageElement {
	const img = document.createElement('img');
	img.alt = alt;
	img.src = src;

	return img;
}

export function createLiWithText(text: string): HTMLLIElement {
	const li = document.createElement('li');
	li.innerHTML = text;

	return li;
}

export function createTdWithText(text: string): HTMLTableCellElement {
	const td = document.createElement('td');
	td.innerHTML = text;

	return td;
}

export function createTdWithElement(...elements: Array<HTMLElement>): HTMLTableCellElement {
	const td = document.createElement('td');
	for (let i = 0; i < elements.length; i++) {
		td.append(elements[i]);
	}

	return td;
}

export function generateOverlay(): HTMLDivElement {
	const overlayElement = document.createElement('div');
	overlayElement.classList.add('modal__overlay');

	return overlayElement;
}

export function createTableBodyLoadingIndicator(): HTMLTableSectionElement {
	const tbody = document.createElement('tbody');
	const spinner = createSpinner();
	const tr = document.createElement('tr');
	const td = createTdWithElement(spinner);
	td.colSpan = 8;
	td.style.textAlign = 'center';
	td.style.fontSize = '40px';
	tr.append(td);
	tbody.append(tr);

	return tbody;
}

export function createCheckedIcon(): HTMLElement {
	const element = document.createElement('i');
	element.classList.add('icon-check');

	return element;
}

export function createIcon(className: string): HTMLElement {
	const element = document.createElement('i');
	element.classList.add(className);

	return element;
}
